export const Commute = {
  toWork: 'to_work',
  fromWork: 'from_work',
} as const;

export type CommuteType = 'to_work' | 'from_work';
